import { Box, Typography } from '@mui/material'
import React, { ReactElement } from 'react'
import BasicTooltip from '../Tooltip/BasicTooltip'
import AvatarComponent from '../avatar/AvatarComponent'
import Voter from '../../store/types/models/Voter'

type LikeDislikeTooltipProps = {
  children: ReactElement
  users: Voter[]
}
export const LikeDislikeTooltip = ({ children, users }: LikeDislikeTooltipProps) => {
  if (!users.length) {
    return children
  }

  return (
    <BasicTooltip
      placement={'bottom'}
      title={
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {users.map(user => (
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }} key={user.id}>
              <AvatarComponent
                extension={user.extension}
                avatar={user.avatar}
                alt={`${user.firstName}-${user.lastName}-profile-picture`}
                size={24}
              />
              <Typography>{`${user.firstName} ${user.lastName}`}</Typography>
            </Box>
          ))}
        </Box>
      }
    >
      {children}
    </BasicTooltip>
  )
}

export default LikeDislikeTooltip